// What the till says when Core's stock check refuses an item.
export const outOfStockMessage = (product) => {
  const name = String(product?.name || "").trim();
  return `${name || "This item"} isn't in stock at this store. Check the stock with the back room or another store.`;
};
